import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateService } from '@ngx-translate/core';

export class AppMissingTranslationHandler implements MissingTranslationHandler {

  handle(params: MissingTranslationHandlerParams) {
    return '<b>**missing translation**</b>';
  }
}



// WEBPACK FOOTER //
// ./src/config/i18n/missing-translation.handler.ts